import styled from 'styled-components'

const WorkspaceNameText = styled.div`
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  font-size: 0.8125rem;
  line-height: 1.5;
  font-weight: 600;
`

const HelpText = styled.div`
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  font-size: 0.6875rem;
  line-height: 1.75;
  font-weight: 400;
  margin-right: 48px; /* this margin is to make the copy line break nicely */
`

export { WorkspaceNameText, HelpText }
